import React, { Component } from 'react'


import Avatar from '../../atoms/Avatar'
import ActionBtnIcon from '../../molecules/ActionBtnIcon'

import { dateTimeFormat } from '../../helpers/Formatter'

import T from '../../translate/T'
import style from './style.css'

export default class Comment extends Component {
    render() {
        let data = this.props.data
        return (
            <div>
                <div className={style.header}>
                    <div className={style.avatar}>
                        <a href={`/${data.user_uri}`}>
                            <Avatar size={30} img={data.user_avatar} />
                        </a>
                    </div>
                    <div className={style.name}>
                        {data.user_name}
                        <br />
                        {data.date && (
                            <div className={style.time}>
                                {dateTimeFormat(T.txt('c_date_hour_format'), data.date)}
                            </div>
                        )}
                    </div>
                    {data.is_admin ? (
                        <div className={style.adminAction}>
                            <div className={style.iconAction}>
                                <ActionBtnIcon size='30' icon='trash' theme='light' action={() => { this.props.handleDelete() }} />
                            </div>
                        </div>
                    ) : (
                        <span />
                    )}
                </div>

                <div className={style.content}>
                    {data.content}
                </div>
                <div className={style.children}>
                    {this.props.children}
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/SPRINTA/molecules/Comment/index.js